<template>
  <f7-page id="register-myinfo-callback-page" name="register-myinfo-callback-page" @page:beforein="init()" @page:afterin="afterin">
    <f7-block>
      &nbsp;
    </f7-block>
  </f7-page>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";

  export default {    
    mounted (){
      /*
      if(window.location.host == "wandrepartner.p2hdevworks.com"){ // stg axs: wandrepartner.p2hdevworks.com, stg wandr-e: wandre.p2hdevworks.com
        window.location.host = "wandre.p2hdevworks.com";
      }else if(window.location.host == "partner.wandr-e.com"){ // prod
        window.location.host = "sendmoney.wandr-e.com";
      }
      */

      this.determineAppBranchId(this.$f7.device.desktop)
      this.routerTo = "register"     
      
      const myInfoState = this.$f7route.query['state'];
      const myInfoCode  = this.$f7route.query['code'];
      const myInfoError = this.$f7route.query['error-description'];

      if(myInfoState && myInfoCode){
        this.code = this.$f7route.query['code'];
        this.state = this.$f7route.query['state'];

        this.setMyInfoState(myInfoState);
        this.setMyInfoCode(myInfoCode);
        this.confirmChoice("yes")
      }else{
        if(myInfoError){
          /*
          this.errorDesc = this.$f7route.query['error-description'];

          this.alertCard.show    = true;
          this.alertCard.title   = decodeURI(this.$f7route.query['error-description']);
          */

          this.confirmChoice("no")
        }
      }
    },
    data() {
      return {
        code      : "",
        state     : "",
        errorDesc : "",
        routerTo  : "",
        fieldList : ["NRIC/FIN","Name","Sex","Date of Birth","Residential Status","Nationality","Pass Type","Pass Status","Pass Expiry Date","Employment Sector","Email","Registered Adrress","Employer's Name","Occupation"],
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
      };
    },
    methods: {
      ...mapActions('myinfo', [
        'setAddress',
        'setDob',
        'setEmail',
        'setEmployerName',
        'setEmploymentSector',
        'setFullname',
        'setGender',
        'setIdentificationNo',
        'setNationality',
        'setOccupation',
        'setPassExpiryDate',
        'setPassStatus',
        'setPassType',
        'setResidentialStatus',
        'setMyInfoState',
        'setMyInfoCode',
      ]),
      ...mapActions('misc', ['determineAppBranchId']),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      init(){
        this.showPreloader();
      },
      confirmChoice(choice){
        // WA-219, Update Account with MyInfo
        if(window.opener.updateAccountMyInfoCallback && window.opener.updateAccountMyInfoCallback !== undefined  && window.opener.updateAccountMyInfoCallback !== null) {
          if(choice == "yes"){          
            window.opener.updateAccountMyInfoCallback(true, this.myInfoState, this.myInfoCode);
          }else{
            window.opener.updateAccountMyInfoCallback(false, this.myInfoState, this.myInfoCode);
          }
          return;
        }
        
        if(choice == "yes"){          
          window.opener.regMyInfoComplete(true, this.myInfoState, this.myInfoCode);
        }else{
          window.opener.regMyInfoComplete(false, this.myInfoState, this.myInfoCode);
          /*
          this.$f7router.navigate("/register");
          this.showPreloader();
          */
        }
      },

      backButton() {
          switch(this.routerTo) {
              case "register" : this.$f7router.navigate("/register"); break;
              default          : this.$f7router.navigate("/register"); break;
          }
      }
    },
    components: {
      
    },
    computed: {
      ...mapGetters('registration', [
          'singpassUrl',
        ]),
      ...mapGetters('myinfo', [
          'myInfoState',
          'myInfoCode',
        ])
    },
  }
</script>